import config from 'shared/config'

export const urlForConversation = (conversationId: number | string) =>
  `/conversations/${conversationId}`

export const deepLinkUrlForConversation = (conversationId: number) =>
  `${config.BASE_URL}/conversations/deep-link?url=${encodeURIComponent(
    `conversations/${conversationId}`
  )}`

export const urlForVisitor = (endUserId: string | number) => {
  if (endUserId === '') {
    return '/conversations'
  }
  return `/conversations/visitors/${endUserId}`
}

export const prefixUrlWithHttp = (link?: string): string | undefined => {
  if (!link) return link

  const VALID_PREFIXES = ['http://', 'https://', 'mailto:']

  for (const prefix of VALID_PREFIXES) {
    if (link.startsWith(prefix)) {
      return link
    }
  }

  return `http://${link}`
}
